/**
 * @author      sam@zumper.com (Sam Sherman)
 * @copyright   Copyright (c) 2020, Zumper
 * @description isNumber
 */

export const isNumber = (arg?: any): arg is number => {
  // null, true and false
  if (arg === null || arg === undefined || arg === true || arg === false) {
    return false
  }
  // empty string, date, or symbol
  if (
    (typeof arg === 'string' && !arg.trim().length) ||
    arg instanceof Date ||
    typeof arg === 'symbol'
  ) {
    return false
  }
  return !isNaN(arg)
}
